import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SignalRConnectionIdService {
  private currentConnectionId = '';

  get connectionId(): string {
    return this.currentConnectionId;
  }

  setConnectionId(connectionId: string): void {
    this.currentConnectionId = connectionId || '';
  }
}
